<template>
  <div class="base-view">
    <SubHeader :title="title">
      <template #info>
        <slot name="info"></slot>
      </template>
      <template #trailing>
        <slot name="trailing"></slot>
      </template>
    </SubHeader>
    <slot name="content"></slot>
  </div>
</template>

<script>
import SubHeader from "../home/SubHeader.vue";

export default {
  name: "BaseView",
  components: {
    SubHeader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.base-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
